import mcslogo from "../../../images/mcs-logo-v2-v2.svg";
import samsungLogoBlack from "../../../images/samsung-logo-black.svg";
import globalConfig from "../../config/global-variables";
import loginModel from "../../models/login.model";
import navigationModel from "../../models/navigation/navigation.model";
import POSMAuthorityModel from "../../models/posm/posm-authority.model";
import profileModel from '../../models/profile.model';
import languagesStorage from '../../storage/languages.storage';
import ViewBase from '../../views/view-base.view';

export default function LoginView() {

  ViewBase.call(this);

  let hasLoginError = false;
  let isLoggingIn = false;
  let hasSubmitted = false;
  let credentials = { userName: "", password: "" };
  let paramGuid = "";
  let isMultipleUser = false;
  let loginUsersOptionList = [];
  let adssoSelectedUserId = "";
  let paramPId = "";

  function getRememberedUserName() {
    if (!localStorage.userName) {
      localStorage.rememberMe = "false";
    }
    if (isRememberMeChecked()) {
      credentials.userName = localStorage.userName;
    }
  }

  function rememberUserName(userName) {
    if (isRememberMeChecked()) {
      localStorage.userName = userName;
    }
  }

  function handleRememberMe(e) {
    localStorage.rememberMe = e.target.checked;

    if (isRememberMeChecked()) {
      localStorage.userName = credentials.userName;
    } else {
      localStorage.userName = "";
    }
  }

  function isRememberMeChecked() {
    return localStorage.rememberMe === "true";
  }

  let login = (e) => {
    e.preventDefault();
    hasSubmitted = true;
    hasLoginError = false;

    if (!credentials.userName || !credentials.password) return;

    isLoggingIn = true;
    this.showLoading();

    return loginModel.login(credentials.userName, credentials.password)
      .then((result) => {
        return getLoginDetails()
          .then(() => { redirect(result.agreementYN) })
      })
      .catch((errorMessage) => {
        hasLoginError = true;
        this.showErrorMessage(errorMessage, "Login Error");
      })
      .finally(() => {
        isLoggingIn = false;
        this.hideLoading();
      })
  }

  function getGUIDFromURL() {
    paramGuid = m.route.param("GUID") || "";
    if (paramGuid) {
      loginViaADSSO();
    }
  }

  let goToADSSOSite = () => {
    isLoggingIn = true;
    this.showLoading();
    window.location.href = `${globalConfig.API_URL}/api/account/auth/sso/ADFSLoginNew`;
  }

  const goToSamsungAccountSite = () => {
    isLoggingIn = true;
    this.showLoading();
    const WEB_PLATFORM = 0
    window.location.href = `${globalConfig.API_URL}/api/account/login/samsung-account?platform=${WEB_PLATFORM}`
  }

  let loginViaADSSO = () => {
    hasLoginError = false;
    isLoggingIn = true;
    this.showLoading();

    paramPId = m.route.param("pid") || "";
    return loginModel.loginADSSO(paramGuid, adssoSelectedUserId, paramPId)
      .then((result) => {
        if (result.mobileSuccessLoginLink) {
          this.routeTo(result.mobileSuccessLoginLink)
        }
        if (result.isMultipleUser) {
          // Multiple user
          isMultipleUser = true;
          populateADSSOUserList(result.userList);
        } else {
          // Single user
          isMultipleUser = false;
          return getLoginDetails()
            .then(() => { redirect(result.agreementYN) });
        }
      })
      .catch((errorMessage) => {
        hasLoginError = true;
        this.showErrorMessage(errorMessage, "ADSSO Login Error");
      })
      .finally(() => {
        isLoggingIn = false;
        this.hideLoading();
      });
  }

  let populateADSSOUserList = (userList) => {
    const firstOption = {
      userID: "",
      name: this.getText("LT00000010", "Choose...")
    }

    adssoSelectedUserId = "";
    loginUsersOptionList = [];

    loginUsersOptionList.push(firstOption);

    userList.map(e => {
      loginUsersOptionList.push({
        userID: e.userID,
        name: e.userID,
      });
    })
  }

  function loginWithSelectedUser(e) {
    adssoSelectedUserId = e.target.value;
    if (adssoSelectedUserId) {
      loginViaADSSO();
    }
  }

  let getLanguageData = () => {
    if (globalConfig.LanguageData == null) {
      return languagesStorage.openDatabase(globalConfig.LanguageDB);
    }
    return null;
  }

  let getProfile = () => {
    return profileModel.getProfile()
      .catch((error) => {
        this.handleError(error);
      })
  }

  const getActiveMenuList = () => {
    return navigationModel.getActiveMenuList()
      .catch(error => {
        this.handleError(error);
      })
  }

  const getPOSMAuthority = () => {
    return POSMAuthorityModel.getAuthorityUserByIDList()
      .catch(error => {
        this.handleError(error);
      })
  }

  let getLoginDetails = () => {
    return Promise.allSettled([getLanguageData(), getProfile(), getActiveMenuList(), getPOSMAuthority()]);
  }

  let isRedirecting = false;

  let getFreshReturnUrl = () => {
    let urlParams = new URLSearchParams(window.location.search);
    let val = urlParams.get('returnUrl');
    if (val) return val;

    const hash = window.location.hash || '';
    const qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
      const hashParams = new URLSearchParams(hash.substring(qIndex + 1));
      val = hashParams.get('returnUrl');
      if (val) return val;
    }

    return m.route.param('returnUrl');
  };

  let redirect = (hasAgreedToEULA) => {
    if (isRedirecting) return;
    let returnUrl = getFreshReturnUrl();
    if (returnUrl) {
      isRedirecting = true;
      returnUrl = decodeURIComponent(returnUrl);
      const loggedInUserId = loginModel.credentials.userName || loginModel.credentials.userID || loginModel.credentials.username;
      const sep = returnUrl.includes('?') ? '&' : '?';
      if (loggedInUserId && !returnUrl.includes('userId=')) {
        returnUrl += `${sep}userId=${encodeURIComponent(loggedInUserId)}`;
      }
      window.location.href = returnUrl;
      return;
    }

    if (hasAgreedToEULA.toUpperCase() === 'Y') {
      this.routeTo('/home');
    } else {
      this.routeTo('/agreement');
    }
  }

  function setUserName(e) {
    credentials.userName = e.target.value;
    rememberUserName(e.target.value);
  }

  function setPassword(e) {
    credentials.password = e.target.value;
  }

  return {
    oninit: function (vnode) {
      getRememberedUserName();
      getGUIDFromURL();
      
      const returnUrl = getFreshReturnUrl();
      // If user already has a valid session and returnUrl exists, bounce immediately
      if (loginModel.isAuthenticated() === true) {
        if (returnUrl) {
          if (isRedirecting) return;
          isRedirecting = true;
          let decUrl = decodeURIComponent(returnUrl);
          const loggedInUserId = loginModel.credentials.userName || loginModel.credentials.userID || loginModel.credentials.username;
          const sep = decUrl.includes('?') ? '&' : '?';
          if (loggedInUserId && !decUrl.includes('userId=')) {
            decUrl += `${sep}userId=${encodeURIComponent(loggedInUserId)}`;
          }
          window.location.href = decUrl;
        } else {
          m.route.set('/home');
        }
      }
    },
    view: (vnode) => {
      return [
        m(".container-login-form",

          m(".form-signin.m-3",
            [
              m("div", { "class": "pb-2" },
                m("div", { "class": "row" },
                  m("div", { "class": "d-flex justify-content-start" },
                    m("img", { "class": "img-responsive samsung-logo-v2", "src": samsungLogoBlack })
                  )
                )
              ),
              m("div", { "class": "p-4" },
                m("div", { "class": "row" },
                  m("div", { "class": "d-flex justify-content-center" },
                    m("img", { "class": "img-responsive login-mcslogo-size", "src": mcslogo })
                  )
                )
              )
            ],
            [
              m(".d-flex", m(".w-100", m("h3.my-4.sign-in-style", "Sign In"))),
              hasLoginError &&
              m('.alert.alert-danger.alert-dismissible.fade.show.wrap-shadow[role="alert"]',
                [
                  m(
                    ".global-invalid-message.d-flex.justify-content-start",
                    [
                      m("i.bi.bi-exclamation-circle-fill.me-2"),
                      "Login Error",
                    ]
                  ),
                  m('button[type="button"].btn-close.x-close-sm', {
                    "data-bs-dismiss": "alert",
                    "aria-label": "Close",
                  }),
                ]
              ),
              m("form.needs-validation[novalidate='novalidate']",
                { onsubmit: login },
                [
                  m(".form-group.mb-3", [
                    m("label.form-label", "User ID"),

                    m(
                      'input[type="text"][autocomplete="off"][required="required"][placeholder="User ID"]',
                      {
                        disabled: isLoggingIn,
                        value: credentials.userName,
                        onchange: setUserName,
                        class:
                          "form-control form-control-bg" +
                          (hasSubmitted &&
                            !credentials.userName
                            ? " redinput-error"
                            : ""),
                      }
                    ),
                    hasSubmitted &&
                    !credentials.userName &&
                    m(".input-invalid-message", [
                      m("i.bi.bi-exclamation-circle-fill"),
                      " User ID is required ",
                    ]),
                  ]),
                  m(".mb-2",
                    m("label.form-label", "Password"),
                    m(
                      'input[type="password"][autocomplete="off"][required="required"][placeholder="Password"]',
                      {
                        disabled: isLoggingIn,
                        value: credentials.password,
                        onchange: setPassword,
                        class:
                          "form-control form-control-bg" +
                          (hasSubmitted &&
                            !credentials.password
                            ? " redinput-error"
                            : ""),
                      }
                    ),
                    hasSubmitted &&
                    !credentials.password &&
                    m(".input-invalid-message",
                      m("i.bi.bi-exclamation-circle-fill"),
                      " Password is required ",
                    ),
                  ),
                  m(".fs-7.d-flex.justify-content-between.gap-2.mb-4",
                    m(".form-check", [
                      m(
                        "input#rememberMe.form-check-input.checkbox-primary-input[type='checkbox']",
                        {
                          checked: isRememberMeChecked(),
                          onclick: handleRememberMe,
                        }
                      ),
                      m(
                        "label.form-check-label.text-muted.mb-2[for=rememberMe]",
                        "Remember Me"
                      ),
                    ]),
                    m(m.route.Link,
                      { href: "/forgot" },
                      "Forgot password"
                    )
                  ),
                  isMultipleUser &&
                  m('.form-group.mb-4', m('label.form-label', this.getText("LT00000009", "User")),
                    m('select.form-select[id="ddlUser"]', {
                      value: adssoSelectedUserId,
                      onchange: loginWithSelectedUser,
                      disabled: isLoggingIn,
                    },
                      loginUsersOptionList.map(user => m('option', { value: user.userID }, user.name))
                    )
                  ),
                  m(".form-group.mb-3.d-flex.flex-column", { style: 'gap: .75em;' }, [
                    m(
                      'button[type="submit"].btn.btn-primary.btn-login',
                      { disabled: isLoggingIn },
                      "Sign In"
                    ),
                    " ",
                    !isMultipleUser && [
                      m("a.btn.btn-secondary[href='javascript:void(0);']", {
                        class: isLoggingIn ? 'disabled' : '',
                        onclick: goToADSSOSite,
                      },
                        "ADSSO",
                        m("span.adsso-btn.fst-normal", "Samsung Employee"),
                      ),
                      m("a.btn.btn-secondary[href='javascript:void(0);']", {
                        class: isLoggingIn ? 'disabled' : '',
                        onclick: goToSamsungAccountSite,
                      },
                        "Samsung Account"
                      ),
                    ]
                  ]),
                ]
              ),
            ]
          )
        ),
        this.getBaseViews()
      ];
    },
  };
}
